import React from 'react'
import styled from 'styled-components'
import { FaWhatsapp } from 'react-icons/fa'
import { HiOutlineMail, HiOutlineLocationMarker } from 'react-icons/hi'
import { BiSend } from 'react-icons/bi'
import emailjs from 'emailjs-com'

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 90px;
    .content {
        display: flex;
        gap: 60px;
        margin-top: 45px;
        .cards {
            display: flex;
            flex-direction: column;
            gap: 30px;
            .card {
                display: flex;
                gap: 8px;
                .icon {
                    font-size: 30px;
                    color: #e2b66b;
                }
                .description {
                    display: flex;
                    flex-direction: column;
                    gap: 8px;
                    .label {
                        font-weight: 600;
                    }
                }
            }
        }
        .form {
            display: flex;
            flex-direction: column;
            gap: 12px;
            .name, .email {
                width: 200px;
                height: 50px;
                border-radius: 5px;
                background-color: rgba(226, 182, 107, 0.3);
                border: none;
            }
            .mensagem {
                width: 300px;
                height: 100px;
                border-radius: 5px;
                background-color: rgba(226, 182, 107, 0.3);
                border: none;
            }
            .button-send {
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 8px;
                padding: 8px 0;
                background-color: #e2b66b;
                border: none;
                border-radius: 6px;
                cursor: pointer;
                font-weight: 600;
                font-size: 16px;
            }
        }
    }

    @media (max-width: 720px) {
        .content {
            flex-direction: column-reverse;
            .cards {
                
            }
        }
    }
`

function ContactMe() {

    function sendEmail(e: React.ChangeEvent<HTMLFormElement>) {
        console.log(e)
        e.preventDefault()

        emailjs.sendForm('service_427hvn9', 'template_daaoxir', e.target, 'user_iG1fq9xAn5TLiRd424hTf')
        .then ((result) => {
            alert('Mensagem enviada')
        }, (error) => {
            alert('Mensagem não enviada')
        })
        e.target.reset()
    }

  return (
      <Wrapper>
            <h2 id='contactMe'>Fale comigo</h2>
            <div className='content'>
                <div className='cards'>
                    <div className='card'>
                        <FaWhatsapp className='icon' />
                        <div className='description'>
                            <span className='label'>WhatsApp</span>
                            <span>(21) 98441-1555</span>
                        </div>
                    </div>
                    <div className='card'>
                        <HiOutlineMail className='icon' />
                        <div className='description'>
                            <span className='label'>E-mail</span>
                            <span>lindiellyjobs@gmail.com</span>
                        </div>
                    </div>
                    <div className='card'>
                        <HiOutlineLocationMarker  className='icon' />
                        <div className='description'>
                            <span className='label'>Localização</span>
                            <span>Rio de Janeiro - RJ</span>
                        </div>
                    </div>
                </div>
                <form className='form' onSubmit={sendEmail} >
                    <input
                    type='text'
                    className='name'
                    name='name'
                    placeholder="Nome"
                    />
                    <input
                    type='text'
                    className='email'
                    name='email'
                    placeholder="Email"
                    />
                    <textarea
                    className='mensagem'
                    name='message'
                    placeholder="Mensagem"
                    />
                    <button
                    className='button-send'
                    type='submit'>
                        <span>Enviar</span>
                        <BiSend />
                    </button>
                </form>
            </div>
      </Wrapper>
  );
}

export default ContactMe;